import * as Actions from '../../actions';

const initialState = { data: null };

const driverRouteSessionsReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_DRIVER_ROUTE_SESSIONS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default driverRouteSessionsReducer;
